import React from 'react';
import { useState } from 'react';
import NotFoundQuotationPresenter from './NotFoundQuotationPresenter';
import RequestForIssueModal from './RequestForIssueModal';
import { CapaQuotationChatRoomStatus } from '@generated/graphql';
import { VerificationDialog } from '@routes/MyAccount/components/Dialog/RequestActionDialog';

export type ModalType = 'purchaseOrder' | 'quotation' | 'notVerified' | null;

interface Props {
  rfqId?: string;
  partnerId?: string;
  chatRoomStatus?: CapaQuotationChatRoomStatus;
}

const NotFoundQuotationContainer = ({
  rfqId,
  partnerId,
  chatRoomStatus
}: Props) => {
  const [type, setType] = useState<ModalType>(null);
  const isClosedConsulting = chatRoomStatus
    ? [
        CapaQuotationChatRoomStatus.ClosedBeforeConsulting,
        CapaQuotationChatRoomStatus.ClosedClient,
        CapaQuotationChatRoomStatus.ClosedConfirm,
        CapaQuotationChatRoomStatus.ClosedPartner
      ].includes(chatRoomStatus)
    : false;

  const handleModal = (type: ModalType) => {
    if (isClosedConsulting) return;
    setType(type);
  };

  return (
    <>
      {!isClosedConsulting && (
        <RequestForIssueModal
          rfqId={rfqId}
          partnerId={partnerId}
          open={Boolean(type)}
          onClose={() => setType(null)}
          type={type}
        />
      )}

      <VerificationDialog
        open={type === 'notVerified'}
        onClose={() => setType(null)}
      />

      <NotFoundQuotationPresenter
        isClosedConsulting={isClosedConsulting}
        handleModal={handleModal}
      />
    </>
  );
};
export default NotFoundQuotationContainer;
